import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
    transform(array: any, sortBy: string, order?: string): any[] {
        let sortOrder: number;
        if (order === 'asc') {
            sortOrder = 1;
        } else if (order === 'desc') {
            sortOrder = -1;
        } else {
            sortOrder = 1;
        }

        return array.sort((n1: any, n2: any) => (this.getProperty(n1, sortBy) > this.getProperty(n2, sortBy) ? 1 * sortOrder : -1 * sortOrder));
    }

    getProperty = (obj: any, path: string) => {
        let output = (path.split('.').reduce((o, p) => o && (o || {})[p], obj) || '').toString().toLowerCase();

        if (!isNaN(output)) {
            return parseInt(output);
        } else {
            return output;
        }
    };
}
